import { observable, action } from 'mobx';

import firstInitStore from './firstInit';
import performanceStore from './performance';
import userStore from './user';
import sessionStore from './session';
import sessionIDListStore from './sessionIDList';

let resolve;

export class CoreStore {
  @observable firstInit;

  constructor() {
    this.firstInit = firstInitStore;
    this.performanceStore = performanceStore;
    this.userStore = userStore;
    this.sessionStore = sessionStore;
    this.sessionIDListStore = sessionIDListStore;
    this.fullStorePromise = new Promise((rs) => {
      resolve = rs;
    });
  }

  updateFullStore() {
    resolve();
  }

  @action
  getStore(storeName) {
    if (this[storeName]) {
      return this[storeName];
    }
    return null;
  }

  @action
  setStore(storeName, storeGetter) {
    if (this[storeName] != null) {
      console.log(`warning: store has injected: '${storeName}'`);
    }
    this[storeName] = storeGetter;
  }

  @action
  getOrSetAndReturn(storeName, storeGetter) {
    const previouslyInstantiatedStore = this.getStore(storeName);
    if (previouslyInstantiatedStore) {
      console.log(
        `LazyStoreRegistry - store with the name '${storeName}' detected. Using existing instance.`,
      );
      return previouslyInstantiatedStore;
    }

    console.log(
      `LazyStoreRegistry - store with the name '${storeName}' not detected. Creating a new instance from the getter method.`,
    );

    this.setStore(storeName, storeGetter);
    return this.getStore(storeName);
  }

  @action
  safeGetStore(storeName) {
    return this.getStore(storeName) || this.getStore('firstInit')[storeName] || {};
  }
}

const coreStore = new CoreStore();

export default coreStore;

export const useLazyStoreInstanceOrCreate = (opts) => {
  return coreStore.getOrSetAndReturn(
    opts.storeName,
    opts.storeGetter,
  );
};
